<div class="pl-0 pt-3" style="margin-left: 2%; margin-right: 2%">
  <div class="row pt-2" style="display: flex; align-items: center; margin-bottom: 3%">
    <div class="col-md-7 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px; color: #262756; font-weight: bold">
        véhicules
      </p>
      <small class="text-uppercase" style="font-size: 15px; color: #959090">Liste des véhicules
      </small>
    </div>
  </div>
  <div class="row rowposition px-0">
    <div class="col-lg-12 col-xl-3 col-md-12 w-100 pl-0">
      <div></div>
    </div>
    <div class="col-12 w-100 pl-0">
      <div class="row w-100 m-0 mb-2">
        <div class="col-2">
          <div class="export-icons d-flex mb-2">
            <div class="icn-sec">
              <img (click)="exportExcel(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg"
                   ngbTooltip="Expoter EXCEL"/>
            </div>
            <div class="icn-sec">
              <img (click)="exportTable()" src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF"/>
            </div>
          </div>
        </div>
        <div class="col-9 w-100" *ngIf="roleuser !== 'User'">
          <div
            *ngIf="listItems.length >1"
            (click)="supprimerItems('moreThanOne',null)"
            class="mat-form-field"
            placement="left"
            ngbTooltip="Supprimer véhicules"
            style="
                  height: 55px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 63px;
                  float: right;
                "
          >
            <mat-icon style="font-size: 25px; padding: 0 !important"
            >delete_forever
            </mat-icon
            >
          </div>
        </div>

        <div class="col-1 w-100" style="text-align: right; margin-top: -20px">

          <img placement="left" *ngIf="roleuser != 'User'" ngbTooltip="Ajouter véhicule" src="assets/icons/add-unit.svg"
               (click)="openDialogFileUpload2()"/>
        </div>
      </div>
      <hr style="border: 1px solid #e8e4e4"/>
      <div class="row" style="justify-content: space-between;">
        <div class="col-lg-3 w-100 col-md-6" *ngIf="roleuser !== 'User'">
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Filtrer Par calibration</mat-label>
            <mat-select [(ngModel)]="searchbycalibration" class="inputModal" [errorStateMatcher]="matcher" required>
              <mat-option (click)="getItemscalibration(calibration)" *ngFor="let calibration of calibrationsearch"
                          [value]="calibration">{{ calibration }}
              </mat-option>
            </mat-select>
            <button mat-button matSuffix mat-icon-button>
              <mat-icon placement="left" ngbTooltip="Actualiser les données des vehicules"
                        (click)="resetdatavihclclbr()">
                update
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-lg-3 w-100 col-md-6" *ngIf="roleuser != 'User'">
          <mat-form-field appearance="fill">
            <mat-label>Filtrer par Compagnie</mat-label>
            <input matInput name="item_id" [(ngModel)]="searchbycompnid" #item_id="ngModel" placeholder="Item"
                   [matAutocomplete]="auto" required (ngModelChange)="applyFilter($event)">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="valueMapper">
              <mat-option *ngFor="let item of filteredData" [value]="item.id" (click)="applyFilterer(item)">
                {{item.name}}
              </mat-option>
            </mat-autocomplete>
            <button mat-button matSuffix mat-icon-button>
              <mat-icon placement="left" ngbTooltip="Actualiser les données des conducteurs"
                        (click)="resetdatavihclcompny()">
                update
              </mat-icon>
            </button>
          </mat-form-field>

        </div>
        <div class="col-lg-3 w-100 col-md-6">
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Filtrer par Type</mat-label>
            <mat-select [(ngModel)]="searchbyunit_type" class="inputModal" [errorStateMatcher]="matcher" required>
              <mat-option (click)="getItemsType(typeVehicules)" *ngFor="let typeVehicules of typeVehicules"
                          [value]="typeVehicules.id">
                <i class="{{ typeVehicules.icon }}"></i>
                {{ typeVehicules.name }}
              </mat-option>
            </mat-select>
            <button mat-button matSuffix mat-icon-button>
              <mat-icon placement="left" ngbTooltip="Actualiser les données des vehicules"
                        (click)="resetdatavihcltype()">
                update
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-lg-3 w-100 col-md-6" *ngIf="roleuser == 'User'">
          <mat-form-field appearance="fill">
            <mat-label>Filtrer par nom</mat-label>
            <input type="text" aria-label="Number" (keyup)="applyFilterer($event)" matInput [(ngModel)]="searchbyname"
                   #input id="getdt" name="getdt" value="{{ searchbyname }}"/>
          </mat-form-field>
        </div>
        <div class="col-lg-3 w-100 col-md-6" *ngIf="roleuser !== 'User'">
          <mat-form-field appearance="fill">
            <mat-label>Chercher par ID du boîtier</mat-label>
            <input type="text" aria-label="Number" (keyup)="applyFiltererbydevcid($event)" matInput
                   [(ngModel)]="searchbydeviceid" #input id="getdt" name="getdt" value="{{ searchbydeviceid }}"/>
          </mat-form-field>
        </div>
      </div>
      <div class="row rowposition pt-3 pl-0 w-100" style="margin-top: 2%">
        <div class="col-12 col-md-12 w-100 mx-3" style="padding: 0px">
          <div class="example-container-contact mat-elevation-z8">
            <ngx-spinner *ngIf="spinnerActiveVehiculeGET != false" bdColor="rgba(100,112,124,0.56)" size="medium"
                         color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="false">
              <p style="color: white"></p>
            </ngx-spinner>
            <table id="ExampleTable" class="table-hover" #exportDirective="matTableExporter" matTableExporter mat-table
                   [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox disabled (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(element) : null"
                                [checked]="selection.isSelected(element)"
                                [aria-label]="checkboxLabel(element)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="calibration">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Calibration
                </th>
                <td mat-cell *matCellDef="let element">
                  <div placement="left" ngbTooltip="{{ element?.calibration }}">
                    <circle-progress [percent]="100" [showSubtitle]="false" [showUnits]="false" [radius]="25"
                                     [outerStrokeWidth]="2" [innerStrokeWidth]="1"
                                     [outerStrokeColor]="updateColor(element?.calibration)"
                                     [innerStrokeColor]="updateColor(element?.calibration)" [animation]="true"
                                     [animationDuration]="700" [titleFontSize]="14"
                                     [title]="updateTitle(element?.calibration)">
                    </circle-progress>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
                <td mat-cell *matCellDef="let element">{{ element?.name }}</td>
              </ng-container>
              <ng-container matColumnDef="device_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [ngStyle]="{ display: roleuser == 'User' ? 'none' : '' }">
                  ID boîtier
                </th>
                <td mat-cell *matCellDef="let element" style="width: 16% !important"
                    [ngStyle]="{ display: roleuser == 'User' ? 'none' : '' }">
                  {{ element?.device_id }}
                </td>
              </ng-container>
              <ng-container matColumnDef="icon">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">
                  <img *ngIf="element?.unit_type_id == 1" ngbTooltip="{{ element?.unit_type }}"
                       src="assets/icons/unit2.svg" style="width: 24; height: 24"/>
                  <img *ngIf="element?.unit_type_id == 2" ngbTooltip="{{ element?.unit_type }}"
                       src="assets/icons/unit2.svg" style="width: 24; height: 24"/>
                  <img *ngIf="element?.unit_type_id == 3" ngbTooltip="{{ element?.unit_type }}"
                       src="assets/icons/unit3.svg" style="width: 24; height: 24"/>
                  <img *ngIf="element?.unit_type_id == 4" ngbTooltip="{{ element?.unit_type }}"
                       src="assets/icons/unit4.svg" style="width: 24; height: 24"/>
                  <img *ngIf="element?.unit_type_id == 5" ngbTooltip="{{ element?.unit_type }}"
                       src="assets/icons/unit1.svg" style="width: 24; height: 24"/>
                </td>
              </ng-container>
              <ng-container matColumnDef="plate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Plaque
                </th>
                <td mat-cell *matCellDef="let element">{{ element?.plate }}</td>
              </ng-container>
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [ngStyle]="{ display: roleuser == 'User' ? 'none' : '' }">
                  Compagnie
                </th>
                <td mat-cell *matCellDef="let element" style="width: 16% !important"
                    [ngStyle]="{ display: roleuser == 'User' ? 'none' : '' }">
                  {{ element?.company }}
                </td>
              </ng-container>
              <ng-container matColumnDef="boitier_sim">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [ngStyle]="{ display: roleuser == 'User' ? 'none' : '' }">
                  SIM
                </th>
                <td mat-cell *matCellDef="let element" [ngStyle]="{ display: roleuser == 'User' ? 'none' : '' }">
                  {{ element?.boitier_sim }}
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                  Actions
                </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{
                    highlight: selectedRowIndex == row?.id && selected == true
                  }">
                  <img [ngClass]="{disable:listItems.length>1}" [ngClass]="{disable:listItems.length>1}"
                       placement="left" *ngIf="roleuser != 'User'" ngbTooltip="Détails du véhicule"
                       src="assets/icons/icon-details.svg" (click)="getItemsbyClick('oneItem',row)"/>
                  <img [ngClass]="{disable:listItems.length>1}" [ngClass]="{disable:listItems.length>1}"
                       placement="left" ngbTooltip="Modifier véhicule" src="assets/icons/icon-modifier.svg"
                       (click)="openDialogFileUpload('oneItem',row)"/>
                  <a [ngClass]="{disable:listItems.length>1}"> <img placement="left" *ngIf="roleuser != 'User'"
                                                                    ngbTooltip="Supprimer véhicule"
                                                                    src="assets/icons/icon-delete.svg"
                                                                    (click)="supprimerItems('oneItem',row?.id)"/></a>


                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"
                  (click)="selection.toggle(row)"
                  (click)="getgogo()"
              ></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="12">
                  Aucune donnée correspondante à votre recherche
                  <!-- "{{ input.value }}" -->
                </td>
              </tr>
            </table>
          </div>
          <mat-paginator #paginator [pageSize]="15" (page)="pageChanged($event)" [length]="dataSource?.data.length"
                         [pageSizeOptions]="[15, 30, 20]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
